import { useGetProductsQuery } from 'src/api/@generated/backend-api';

import { selectSelectedAccountOrThrow } from 'src/state/account/selectors';
import { selectSelectedServiceLocationOrThrow } from 'src/state/address/selectors';
import { useAppSelector } from 'src/state/thunk-api';

export const useProductsResponseQueryStateOrThrow = () => {
  const { productsResponse } = useProductsQuery();

  if (!productsResponse?.products) {
    throw new Error('Products data must be present');
  }

  return { ...productsResponse.products };
};

export const useProductsQuery = () => {
  const selectedAccount = useAppSelector(selectSelectedAccountOrThrow);
  const selectedServiceLocation = useAppSelector(selectSelectedServiceLocationOrThrow);

  const { data: productsResponse, isLoading } = useGetProductsQuery({
    partnerId: selectedAccount.partnerId,
    billingAccountId: selectedAccount.customerId,
    servicePointId: selectedServiceLocation.integrationId,
  });

  return { productsResponse, isLoading };
};
